import { createFileRoute, Outlet } from '@tanstack/react-router'

function    OnboardingLayout() {
    return (
      <section
        className="flex w-full flex-col justify-center"
        role="region"
        aria-labelledby="weight-loss-heading"
      >
        {/* <DashboardHeader items={weightLossNavigationItems} title="Weight Loss" /> */}
        <Outlet />
      </section>
    );
  } 

export const Route = createFileRoute('/(dashboard)/dashboard/onboarding')({
  component: () => <OnboardingLayout />,
  errorComponent: ({ error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Error Loading Onboarding Page</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
})

// function RouteComponent() {
//   return <div>Hello "/(dashboard)/dashboard/onboarding"!</div>
// }
